import React from 'react'
import PropTypes from 'prop-types'

import PageTemplate from 'components/page-template'
import notify from 'utils/notification'
import Auth from 'services/auth/auth-service'
import * as request from 'services/request'

class InstagramAuth extends React.Component {
  componentWillMount () {
    const {
      error,
      error_reason: reason,
      error_description: description
    } = this.props.location.query

    if (error) {
      notify.error({
        title: reason,
        message: description
      })
      this.redirectToSettings()
    }
  }

  componentDidMount () {
    const { code } = this.props.location.query
    if (code) {
      this.save(code)
      return
    }

    this.redirectToSettings()
  }

  redirectToSettings () {
    const { router } = this.context
    router.replace('/settings')
  }

  async save (code) {
    const id = Auth.id
    const getUrl = window.location
    const rootUri = `${getUrl.protocol}//${getUrl.host}`
    const redirectUri = `${rootUri}/auth/instagram`

    try {
      const response = await request.authorized(
        `/users/${id}/auth/instagram/${code}`,
        {
          method: 'POST',
          body: {
            redirectUri
          }
        }
      )
      const { username } = await response.json()

      notify.success({
        message: `Successfully connected account '${username}' to Instagram!`
      })
    } catch (e) {
      notify.error({
        title: 'Failed to connect Instagram',
        message:
          'Please retry connecting your Instagram account, or contact your administrator if the problem persists'
      })
    } finally {
      this.redirectToSettings()
    }
  }

  // this page duplicates the look of the profile settings ('/settings') page
  render () {
    return (
      <PageTemplate
        title='Your Profile Settings'
        description='Change your settings'
      >
        <h3>Connecting to Instagram...</h3>
      </PageTemplate>
    )
  }
}

InstagramAuth.displayName = 'InstagramAuth'
InstagramAuth.propTypes = {
  location: PropTypes.shape({
    query: PropTypes.shape({
      code: PropTypes.string,
      error: PropTypes.string,
      error_reason: PropTypes.string,
      error_description: PropTypes.string
    })
  })
}

InstagramAuth.contextTypes = {
  router: PropTypes.object
}

export default InstagramAuth



// WEBPACK FOOTER //
// ./src/pages/auth/instagram/index.js